import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'acorn-popup',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
})
export class GoalSuccessPopupComponent {}
